import { ActionButton } from "Components"
import { GatsbyImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import { mixins } from "Styles"
import { theme } from "Theme"

const TextBlock = styled.div`
  margin-bottom: 1rem;
  text-align: left;
  @media (min-width: ${theme.breakpoints.m}) {
    margin: ${(props) => (props.layout == "ltr" ? `0 4rem 0 0` : `0 0 0 4rem`)};
  }
`

const Title = styled.h3`
  color: ${theme.colors.white.base};
  font-size: ${theme.fontSize.h3};
  font-weight: bold;
  max-width: ${theme.layout.base};
`

const Subtitle = styled.p`
  color: ${theme.colors.white.base};
  font-size: ${theme.fontSize.medium};
  margin-bottom: 0;
  & + a {
    margin-top: 1rem;
  }
`

const Wrapper = styled.div`
  background: none;
  min-height: 400px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  ${mixins.backgroundBefore};
  align-items: center;
  padding: 4rem 2rem;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    padding: 2rem 2rem;
    width: 100%;
  }
  @media (min-width: ${theme.breakpoints.l}) {
    padding: 2rem 0;
  }
  .gatsby-image-wrapper {
    position: initial !important;
  }
`

const Content = styled.div`
  color: ${theme.colors.white.base};
  max-width: ${theme.layout.base};
  width: 100%;
  max-width: ${theme.layout.base};
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: ${(props) => (props.layout == "ltr" ? `row` : `row-reverse`)};
  flex-direction: column;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    flex-direction: ${(props) => (props.layout == "ltr" ? `row` : `row-reverse`)};
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  justify-content: space-between;
  margin: 0 auto;
  max-width: ${theme.layout.base};
  text-align: ${(props) => (props.layout == "ltr" ? `right` : `left`)};
  max-width: ${theme.layout.base};
  align-items: center;
  font-size: ${theme.fontSize.large};
`

const SectionBackground = ({ layout, image, title, subtitle, cta_text, cta_url, cta_text_1, cta_url_1, children }) => (
  <Wrapper>
    {image && <GatsbyImage alt={""} title={title} image={image.childImageSharp.gatsbyImageData || {} || [] || ""} />}
    <Content layout={layout}>
      <TextBlock layout={layout}>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
        {cta_text && (
          <ActionButton href={cta_url} title={cta_text}>
            {cta_text}
          </ActionButton>
        )}
        {cta_text_1 && (
          <ActionButton href={cta_url_1} title={cta_text_1}>
            {cta_text_1}
          </ActionButton>
        )}
      </TextBlock>
      {children && children}
    </Content>
  </Wrapper>
)

export default SectionBackground

SectionBackground.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]),
}

SectionBackground.defaultProps = {
  children: false,
  image: false,
  title: false,
}
